import React, { useContext } from 'react'
import { UserdataContext } from '../../../App'
import UnloggedOffers from '../unlogged-area/offers'

const OffersWrapper = () => {
  const { userData } = useContext(UserdataContext)
  
  // Para todos os usuários (candidatos, recrutadores e não logados), 
  // renderiza a página de ofertas gerais com cards
  return <UnloggedOffers />
}

export default OffersWrapper
